import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useBlogs } from '../../hooks/useBlogs';

export default function BlogPosts({ hideHeading = false, limit }) {
  const { data } = useBlogs();
  const posts = limit ? data.slice(0, limit) : data;
  return (
    <section id="insights" className={`relative bg-black ${hideHeading ? 'pb-24 md:pb-32' : 'py-24 md:py-32'}`} data-testid="blog-list">
      <div className="max-w-[1500px] mx-auto px-6">
        {!hideHeading && (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <h2 className="font-display text-[#f4efe6] uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            Insights & <span className="font-script text-[#00b8ff] normal-case italic">Stories</span>
          </h2>
          <Link to="/blog" className="text-[#f4efe6] font-semibold border-b border-[#00b8ff] pb-1 hover:text-[#00b8ff] transition-colors duration-200 self-start md:self-auto" data-testid="blog-all-link">
            All articles
          </Link>
        </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7 md:gap-8">
          {posts.map((post) => (
            <article key={post.slug} className="group flex flex-col">
              <Link
                to={`/blog/${post.slug}`}
                className="block relative overflow-hidden rounded-md aspect-[4/3] mb-6"
                aria-label={post.title}
              >
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none" />
              </Link>
              <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] text-[#00b8ff] mb-3">
                {post.category && <span>{post.category}</span>}
                {post.category && post.readTime && <span className="w-1 h-1 rounded-full bg-[#00b8ff]/60" />}
                {post.readTime && <span className="text-[#cfc8bb]">{post.readTime}</span>}
              </div>
              <h3 className="font-display text-[#f4efe6] uppercase text-2xl md:text-3xl leading-[1.05] tracking-tight mb-4">
                <Link to={`/blog/${post.slug}`} className="hover:text-[#00b8ff] transition-colors duration-200">
                  {post.title}
                </Link>
              </h3>
              <p className="text-[#cfc8bb] text-sm md:text-base leading-relaxed mb-5">
                {post.excerpt}
              </p>
              <Link
                to={`/blog/${post.slug}`}
                className="inline-flex items-center gap-2 text-[#f4efe6] text-sm font-semibold hover:text-[#00b8ff] transition-colors duration-200 group/cta"
              >
                Read article
                <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover/cta:translate-x-1" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
